module.exports = __webpack_public_path__ + "img/simpleFinance.adb76af7.png";